import actions from "webmodals/action-list";
import dialog from "webmodals/dialog";
import alert from "webmodals/alert";
import confirm from "webmodals/confirm";
import acknowledge from "webmodals/acknowledge";
import prompt from "webmodals/prompt";
import busy from "webmodals/busy";
import open from "webmodals/open";

export default {
  open,
  dialog,
  alert,
  confirm,
  actions,
  acknowledge,
  prompt,
  busy,
};
